import defaultColors from '@elegantstack/solid-ui-theme/src/colors';

//Using tailwind preset colors
import colorPreset from '@elegantstack/solid-ui-theme/src/color-preset';

const colors = {
  ...defaultColors,
  alphaLighter: colorPreset.blueGray[200],
  alphaLight: colorPreset.blueGray[300],
  alpha: colorPreset.blueGray[700],
  alphaDark: colorPreset.blueGray[800],
  alphaDarker: colorPreset.blueGray[900],
};

export default colors;
